import React from "react";
import Icon from "@ant-design/icons";

const SparkleBigSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
	stroke = "#344054",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M16.3553 26.5064L15 31.25L13.6447 26.5063C12.9328 24.0148 10.9852 22.0672 8.49365 21.3553L3.75 20L8.49365 18.6447C10.9852 17.9328 12.9328 15.9852 13.6447 13.4936L15 8.75L16.3553 13.4937C17.0672 15.9852 19.0148 17.9328 21.5064 18.6447L26.25 20L21.5063 21.3553C19.0148 22.0672 17.0672 24.0148 16.3553 26.5064Z"
			stroke={stroke}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M30.4314 14.5242L30 16.25L29.5686 14.5242C29.0647 12.5089 27.4911 10.9353 25.4758 10.4314L23.75 10L25.4758 9.56856C27.4911 9.06472 29.0647 7.49112 29.5686 5.47577L30 3.75L30.4314 5.47577C30.9353 7.49112 32.5089 9.06472 34.5242 9.56856L36.25 10L34.5242 10.4314C32.5089 10.9353 30.9353 12.5089 30.4314 14.5242Z"
			stroke={stroke}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M28.1571 34.2788L27.5 36.25L26.8429 34.2788C26.4697 33.159 25.591 32.2803 24.4712 31.9071L22.5 31.25L24.4712 30.5929C25.591 30.2197 26.4697 29.341 26.8429 28.2212L27.5 26.25L28.1571 28.2212C28.5303 29.341 29.409 30.2197 30.5288 30.5929L32.5 31.25L30.5288 31.9071C29.409 32.2803 28.5303 33.159 28.1571 34.2788Z"
			stroke={stroke}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
const SparkleBigIcon = (props) => (
	<Icon component={() => <SparkleBigSvg {...props} />} />
);

export default SparkleBigIcon;
